import {NavLink} from "react-router-dom";
import {ColourMod, Placement} from "../../Data/Enums/LayoutEnums";
import {FC} from "react";
import Badge from "../Badges/Badge";
import {useLayout} from "../../Providers/LayoutProvider";

export interface iSideNavigation {
    isBranded?: boolean;
    showLogo?: boolean;
    showMenuModifier?: boolean;
}

export interface iMainMenuEntry {
    title: string;
    url: string;
    icon: any;
    badgeCount?: number | string;
    customCallBack?: () => void;
}

const BuildEntry: FC<iMainMenuEntry> = (props) => {
    const {sidebarOpen, isUltraWide} = useLayout();

    const EntryContent = () => {
        return (
            <>
                {!!props.icon && props.icon}
                {(sidebarOpen || isUltraWide) && (
                    <div className={'navigation-label'}>
                        {props.title}
                    </div>
                )}
                {!!props.badgeCount && (
                    <Badge description={props.badgeCount as string} count={props.badgeCount as number} colour={ColourMod.Alert} placement={(sidebarOpen || isUltraWide) ? Placement.Right : Placement.TopRight} />
                )}
            </>
        )
    }
    
    if(props.customCallBack) {
        return (
            <div
                onClick={() => props.customCallBack ? props.customCallBack() : console.log('Build Entry: Custom callback has no callback')}
                className={'side-navigation-entry collapsable'}
                tabIndex={0}
            >
                <EntryContent />
            </div>
        )
    }

    return (
        <NavLink
            className={`side-navigation-entry collapsable`}
            to={props.url}
            title={props.title}
        >
				<EntryContent />
        </NavLink>
    );
};

export default BuildEntry;